import { BeforeYouSyncModal, BeforeYouSyncModalProps } from "./BeforeYouSyncModal"

export const BeforeYouSyncModalAutel = (props: BeforeYouSyncModalProps) => {
    return (
        <BeforeYouSyncModal {...props}>
            <h4 className="text-gray-0 text-center mt-4">
                Before continuing, ensure all your flights have finished syncing to the cloud.
                <br />
                <br />
                <a
                    className="underline text-blue-500 hover:text-blue-300"
                    href="https://www.autelpilot.com/blogs/tips-tutorials/how-to-check-the-flight-log-of-autel-drones"
                    target="about:blank"
                >
                    How to sync from Autel Explorer
                </a>
            </h4>
        </BeforeYouSyncModal>
    )
}
